import { create } from "zustand";
import { initialState, THelperStore } from "./helper.state";
import { createHelperActions } from "./helper.actions";

/**
 * State management store for new parts of the V3 search
 * @example
 * ```
 * const isModalOpen = useHelperStore((state) => state.isModalOpen)
 * const dispatch = useHelperStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_IS_MODAL_OPEN, payload: false })
 * ```
 */
export const useHelperStore = create<THelperStore>((set) => ({
    ...initialState,
    ...createHelperActions(set),
}));
